import { EventEmitter } from "events";
import { ISession } from "features/manage/sessions/ISession";
import { Pipeline, Request } from "lib/HTTP";
import { UrlProvider } from "lib/UrlProvider";

export class SessionsStore extends EventEmitter {
    private static _instance: SessionsStore = new SessionsStore();
    private urlProvider = new UrlProvider();

    private constructor() {
        super();
    }

    public static get instance(): SessionsStore {
        return SessionsStore._instance;
    }

    async getAll(): Promise<ISession[]> {
        const url = `${this.urlProvider.nextRoot}/api/v1/me/sessions`;
        const response = await new Pipeline().fetch(
            url,
            this.authenticatedRequest(Request.get, url)
        );
        const data = await response.json() as { items: ISession[] };
        return data.items || [];
    }

    async revoke(id: string): Promise<void> {
        const url = `${this.urlProvider.nextRoot}/api/v1/me/sessions/${id}`;
        await new Pipeline().fetch(
            url,
            this.authenticatedRequest(Request.delete, url)
        );
        this.emit("SessionRevoked", id);
    }

    async revokeOthers(): Promise<void> {
        const url = `${this.urlProvider.nextRoot}/api/v1/me/sessions`;
        await new Pipeline().fetch(
            url,
            this.authenticatedRequest(Request.delete, url)
        );
        this.emit("OtherSessionsRevoked");
    }

    public onSessionRevoked(callback: (id: string) => void) {
        this.on("SessionRevoked", callback);
    }

    public onOtherSessionsRevoked(callback: () => void) {
        this.on("OtherSessionsRevoked", callback);
    }

    private authenticatedRequest(base: Request, url: string): Request {
        const req = base.authenticate(undefined, url);
        req.headers["X-Scope"] = "full";
        req.headers["X-Application-Name"] = "Linkstacks Web";
        return req;
    }
}
